module.exports = __webpack_public_path__ + "img/14_bohle.226ef85c.jpeg";